(() => {
  const trigger = document.getElementById('fw-reservation-trigger');
  const modal = document.getElementById('fw-reservation-modal');
  const iframe = document.getElementById('fw-reservation-iframe');
  const closeButton = modal?.querySelector(
    '[data-fw-reservation-close]'
  );

  if (!trigger || !modal || !iframe) {
    return;
  }

  function loadReservation() {
    if (iframe.hasAttribute('src')) {
      return;
    }

    const iframeSource = iframe.dataset.src;

    if (!iframeSource) {
      return;
    }

    iframe.src = iframeSource;
  }

  function openReservation(event) {
    /*
     * Falls <dialog> aus irgendeinem Grund nicht unterstützt
     * wird, lassen wir den normalen href-Fallback funktionieren.
     */
    if (typeof modal.showModal !== 'function') {
      return;
    }

    event.preventDefault();

    loadReservation();

    if (!modal.open) {
      modal.showModal();
    }
  }

  function closeReservation() {
    if (modal.open) {
      modal.close();
    }
  }

  trigger.addEventListener('click', openReservation);

  closeButton?.addEventListener('click', closeReservation);

  /*
   * Klick auf den dunklen Bereich außerhalb des Dialogs.
   */
  modal.addEventListener('click', (event) => {
    if (event.target !== modal) {
      return;
    }

    const rect = modal.getBoundingClientRect();

    const clickIsInside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!clickIsInside) {
      closeReservation();
    }
  });

  /*
   * ESC übernimmt <dialog> bereits nativ.
   * Danach Fokus zurück auf den ursprünglichen CTA.
   */
  modal.addEventListener('close', () => {
    trigger.focus({
      preventScroll: true
    });
  });
})();